// frontend/src/stores/filter.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useFilterStore = defineStore('filter', () => {
  // Filter state
  const filterType = ref('all')
  const filterMinSpeed = ref(0)
  const filterMaxSpeed = ref(50)
  const filterStatus = ref('all')
  
  // Method to update filter - PERBAIKAN: tambahkan logging
  function setFilterType(type) {
    filterType.value = type
  }
  
  function setFilterMinSpeed(speed) {
    filterMinSpeed.value = speed
  }
  
  function setFilterMaxSpeed(speed) {
    filterMaxSpeed.value = speed
  }
  
  function setFilterStatus(status) {
    filterStatus.value = status
  }
  
  function setFilters({ type, minSpeed, maxSpeed, status }) {
    if (type !== undefined) {
      filterType.value = type
    }
    if (minSpeed !== undefined) {
      filterMinSpeed.value = minSpeed
    }
    if (maxSpeed !== undefined) {
      filterMaxSpeed.value = maxSpeed
    }
    if (status !== undefined) {
      filterStatus.value = status
    }
  }
  
  function resetFilters() {
    filterType.value = 'all'
    filterMinSpeed.value = 0
    filterMaxSpeed.value = 50
    filterStatus.value = 'all'
  }
  
  // Get active filter count
  const activeFilterCount = computed(() => {
    let count = 0
    if (filterType.value !== 'all') count++
    if (filterMinSpeed.value > 0) count++
    if (filterMaxSpeed.value < 50) count++
    if (filterStatus.value !== 'all') count++
    return count
  })
  
  // Check if any filter is active
  const hasActiveFilters = computed(() => {
    return filterType.value !== 'all' || 
           filterMinSpeed.value > 0 || 
           filterMaxSpeed.value < 50 ||
           filterStatus.value !== 'all'
  })
  
  return {
    // State
    filterType,
    filterMinSpeed,
    filterMaxSpeed,
    filterStatus,
    
    // Computed
    activeFilterCount,
    hasActiveFilters,
    
    // Actions
    setFilterType,
    setFilterMinSpeed,
    setFilterMaxSpeed,
    setFilterStatus,
    setFilters,
    resetFilters
  }
})